import React from 'react'
import './FondoMovil.css'
import Background from '../../img/background.png'
import FotoFondo from '../../img/FotoFondo.png'
import FotoFondo2x from '../../img/FotoFondo2x.png'
import FotoMapa from '../../img/Fotomapa.png'
import FotoMapa2x from '../../img/Fotomapa2x.png'
import Trazado from '../../img/Trazado.png'
import Trazado2x from '../../img/Trazado2x.png'


function FondoMovil() {
  return (
    <div className='Fondomovil'> 
      <img id='fondoFM' src={Background}/>
      {/* <img id='verdeFM' src={Trazado}/> */}
      <div id='verdeFM'></div>
      {/* <img id='mapaFM' src={FotoMapa}/> */}
    </div>
  )
}

export default FondoMovil